<template>
    <div class="row mt-3 justify-content-center">
        <div class="col-12" style="max-width: 20rem">
            <div class="row">
                <div class="col-12">
                    <div class="card card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <FormPreviewField
                                    :title="$t('scan.titles.full_name')"
                                    :value="form.firstname +' '+ form.lastname"
                                />

                                <FormPreviewField
                                    :title="$t('scan.titles.form_type')"
                                    :value="$t('scan.formTypes.' + form.typeForm)"
                                />

                                <hr v-if="form?.parent">

                                <FormPreviewField
                                    v-if="form?.parent"
                                    :title="$t('scan.titles.invited_by')"
                                    :value="form.parent.firstname +' '+ form.parent.lastname"
                                />
                                <FormPreviewField
                                    v-if="form?.parent"
                                    :title="$t('scan.titles.form_type')"
                                    :value="$t('scan.formTypes.' + form?.parent?.typeForm)"
                                />
                            </div>
                            <div class="col-md-12 mt-3">
                                <div>{{ $t('scan.titles.active_permissions') }}</div>
                                <span
                                    v-for="(_, value) in getActivePermissions"
                                    class="badge text-bg-primary rounded-0 m-1"
                                    :key="value"
                                >
                            <span >
                                {{ value }}
                            </span>
                        </span>
                            </div>
                            <div class="col-md-12 mt-3">
                                <div v-if="hasTransportPermission" class="alert alert-success mb-0" role="alert">
                                    {{ $t('scan.alerts.has_permission') }}
                                </div>
                                <div v-else class="alert alert-danger mb-0" role="alert">
                                    {{ $t('scan.alerts.no_permission') }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12 d-flex">
                    <a class="btn btn-secondary me-auto" href="/merchant/transport/scan">
                        {{ $t('scan.buttons.back') }}
                    </a>

                    <a v-if="hasTransportPermission" class="btn btn-primary" href="#" @click.prevent="onOpenModal">
                        {{ $t('scan.buttons.insert_queue') }}
                    </a>
                </div>
            </div>
        </div>
    </div>


    <div ref="createModal" class="modal fade" tabindex="-1" id="createModal" data-bs-backdrop="static" >
        <div class="modal-dialog modal-fullscreen-md-down">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="staticBackdropLabel">
                        {{ form.firstname +' '+ form.lastname }}
                    </h1>
                    <button type="button" class="btn-close" @click.prevent="onCloseModal"></button>
                </div>

                <div class="modal-body">
                    <TransportCreateForm
                        :item="form"
                        @created="onCloseModal"
                    />
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import MerchantLayout from "../../../Layouts/MerchantLayout.vue";
import FormPreviewField from "../../../components/FormPreviewField.vue";
import TransportCreateForm from "../../../components/Widget/TransportCreateForm.vue";
import * as Bootstrap from "bootstrap"

export default {
    name: "AcForm",
    layout: MerchantLayout,
    props: {
        form: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            createModal: null
        }
    },
    computed: {
        getActivePermissions() {
            let result = {};

            for (const permissionsKey in this.form.permissions) {
                if (this.form.permissions[permissionsKey] !== 0) {
                    result[permissionsKey] = this.form.permissions[permissionsKey];
                }
            }

            return result;
        },
        hasTransportPermission() {
            return Object.keys(this.getActivePermissions).includes('coche_oficial')
        }
    },
    methods: {
        onOpenModal() {
            this.createModal.show()
        },
        onCloseModal() {
            this.createModal.hide();
        }
    },
    mounted() {
        this.createModal = new Bootstrap.Modal('#createModal');
    },
    components: {
        FormPreviewField,
        TransportCreateForm
    }
}
</script>

<style scoped>

</style>
